import axios from 'axios'
import SessionManager from '../../Utils/SessionManager'

const base = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}whatsapp/`

const schoolCode = () => SessionManager.getSchoolCode()

const REQ_TIMEOUT_MS = 20000

// Created By Cursor
async function get(path, params = {}) {
  const { data } = await axios.get(`${base()}${path}`, {
    params: { school_code: schoolCode(), ...params },
    timeout: REQ_TIMEOUT_MS,
  })
  return data
}

// Created By Cursor
async function post(path, body = {}) {
  const { data } = await axios.post(`${base()}${path}`, {
    school_code: schoolCode(),
    ...body,
  }, { timeout: REQ_TIMEOUT_MS })
  return data
}

const whatsappApi = {
  // Created By Cursor — use whatsapp/ folder APIs (same as other WhatsApp endpoints)
  getAccount: () => get('getAccount.php'),
  // Created By Cursor — live Meta phone connection check (12s timeout)
  checkConnection: () =>
    axios
      .get(`${base()}checkConnection.php`, {
        params: { school_code: schoolCode() },
        timeout: 12000,
      })
      .then(({ data }) => data),
  // Created By Cursor — Cloud API /register (fixes #133010)
  registerPhone: (pin) => post('registerPhone.php', pin ? { pin } : {}),
  // Created By Cursor
  getServiceStatus: () => get('getServiceStatus.php'),
  // Created By Cursor
  onboardInit: () => post('onboardInit.php', {}),
  // Created By Cursor
  onboardCallback: (payload) => post('onboardCallback.php', payload),
  // Created By Cursor
  getWallet: () => get('getWallet.php'),
  // Created By Cursor
  walletTransactions: (page = 1, limit = 20) =>
    get('walletTransactions.php', { page, limit }),
  // Created By Cursor
  walletRecharge: (amount) => post('walletRecharge.php', { amount }),
  // Created By Cursor
  walletConfirmRecharge: (reference_id, payment_ref) =>
    post('walletConfirmRecharge.php', { reference_id, payment_ref }),
  // Created By Cursor
  getPricePlans: () => get('getPricePlans.php'),
  // Created By Cursor
  getSubscription: () => get('getSubscription.php'),
  // Created By Cursor
  assignSubscription: (plan_id) => post('assignSubscription.php', { plan_id }),
  // Created By Cursor
  getWhatsappSchoolMessageServices: (activeOnly = true) =>
    get('getWhatsappSchoolMessageServices.php', { active_only: activeOnly ? 1 : 0 }),
  // Created By Cursor — alias
  getMessageServices: (activeOnly = true) =>
    get('getWhatsappSchoolMessageServices.php', { active_only: activeOnly ? 1 : 0 }),
  // Created By Cursor
  getTemplates: () => get('getTemplates.php'),
  // Created By Cursor
  createTemplate: (payload) => post('createTemplate.php', payload),
  // Created By Cursor
  submitTemplateToMeta: (template_id) =>
    post('submitTemplateToMeta.php', { template_id }),
  // Created By Cursor — approved templates: fetch Meta body/vars and sync DB
  verifyTemplateFromMeta: (template_id, apply_sync = true) =>
    post('verifyTemplateFromMeta.php', {
      template_id,
      apply_sync: apply_sync ? 1 : 0,
    }),
  // Created By Cursor
  getReports: (params) => get('getReports.php', params),
  // Created By Cursor — Meta WABA pricing_analytics (display only; pay in Meta Suite)
  getMetaBilling: (params = {}) => get('getMetaBilling.php', params),
  // Created By Cursor
  getFeeDueRecipients: (params) => get('getFeeDueRecipients.php', params),
  // Created By Cursor
  getStudentsForMessaging: (params) => get('getStudentsForMessaging.php', params),
  // Created By Cursor — class-wise contacts + format status (Settings tab)
  getStudentContactsByClass: (params) => get('getStudentContactsByClass.php', params),
  // Created By Cursor — format + best-effort WhatsApp presence check
  verifyContacts: (contacts, check_whatsapp = true) =>
    post('verifyContacts.php', {
      contacts,
      check_whatsapp: check_whatsapp ? 1 : 0,
    }),
  // Created By Cursor — manual verify: mark tm_student_contact.is_whatsapp_number=1
  markStudentContactVerified: (payload) => post('markStudentContactVerified.php', payload),
  // Created By Cursor
  getQueue: (group = 'pending', limit = 100, offset = 0) =>
    get('queue.php', { group, limit, offset }),
  // Created By Cursor
  addToQueue: (payload) => post('addToQueue.php', payload),
  // Created By Cursor
  getInboxConversations: (params = {}) =>
    get('inbox.php', { action: 'conversations', ...params }),
  // Created By Cursor
  getInboxThread: (contact, limit = 200) =>
    get('inbox.php', { action: 'thread', contact, limit }),
  // Created By Cursor
  sendInboxReply: (contact_number, message, staff_id) =>
    post('inbox.php', { action: 'reply', contact_number, message, staff_id }),
  // Created By Cursor
  markInboxRead: (contact_number) =>
    post('inbox.php', { action: 'mark_read', contact_number }),
  // Created By Cursor
  send: (payload) =>
    post('send.php', {
      request_id:
        payload.request_id ||
        `wa_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`,
      ...payload,
    }),
}

export default whatsappApi
